import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

interface SocialLink {
  label: string;
  href: string;
  icon: 'facebook' | 'instagram' | 'tiktok';
}

@Component({
  selector: 'app-home-page',
  imports: [RouterLink],
  templateUrl: './home-page.html',
  styleUrl: './home-page.css',
})
export class HomePage {
  public socialLinks: SocialLink[] = [
    { label: 'فەیسبووک', href: 'https://www.facebook.com/share/g/19RNFe3qcS/', icon: 'facebook' },
    { label: 'ئینستاگرام', href: 'https://www.instagram.com/asanjoboffice', icon: 'instagram' },
    { label: 'تیکتۆک', href: 'https://www.tiktok.com/@asanjoboffice', icon: 'tiktok' },
  ];

  public phones: string[] = [
    '009647705059539',
    '009647705059549',
    '009647518543350',
  ];
}
